module.exports = __webpack_public_path__ + "img/creative-team-animate.46bea1c7.svg";